export default "__VITE_PUBLIC_ASSET__d7136968__"